import { APIs } from "../../../../../../../util/api/APIs";
import SafeairManager from "../../../../../../../util/api/SafeairManager";

class CreateOrganizationService {
  async addOrganization(
    name: string,
    address: string,
    phoneNumbers: string[],
    emails: string[]
  ) {
    const response = await SafeairManager.invoke({
      api: APIs.Organization.CreateOrganization,
      parameters: null,
      body: {
        name,
        address,
        phoneNumbers, // Array of phone numbers
        emails, // Array of emails
      },
    });
    return response;
  }
  async editOrganization(
    id: string,
    name: string,
    address: string,
    phoneNumbers: string[],
    emails: string[]
  ) {
    const config = {};
    const response = await SafeairManager.invoke({
      api: APIs.Organization.UpdateOrganization,
      parameters: { id: id },

      body: {
        // name,
        // address,
        // phoneNumber,
        // email
        id: id,
        name: name,
        address: address,
        phoneNumbers: phoneNumbers,
        emails: emails,
      },
    });
    return response;
  }
}

export default new CreateOrganizationService();
